import { Controller } from "@hotwired/stimulus"

// The look-alike strip while a review is being prepared ("The agent is
// checking 23 tasks like this one"). It reloads its own Turbo Frame every few
// seconds, so the strip says "Review 22 tasks" when the review is ready,
// even after the person closed the review's window. It stops by itself: the
// frame's next state has no controller, and a run that takes longer than
// MAX_RELOADS is left for the person to reload.
const RELOAD_MS = 4000
const MAX_RELOADS = 150

export default class extends Controller {
  connect() {
    const frame = this.element.closest("turbo-frame")
    if (!frame || !frame.src) return

    const reloads = Number(frame.dataset.similarStripReloads || 0)
    if (reloads >= MAX_RELOADS) return

    this.timer = setTimeout(() => {
      frame.dataset.similarStripReloads = String(reloads + 1)
      frame.reload()
    }, RELOAD_MS)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
